import IntroCanvas from "./_canvas";

export default class Main {
    constructor() {
        this.IntroCanvas = new IntroCanvas();
        //this._init();
    }

    _init() {
        const iCanvas = new IntroCanvas();
        window.addEventListener("load", () => {
            document.body.classList.add("-introin");

            if (STORAGE.data.ThemaColor === "tengoku" || STORAGE.data.ThemaColor === "") {
                iCanvas.render("tengoku");
            } else {
                iCanvas.render("makyou");
            }
        });
    }

    _hideTxt() {
        const txtr = document.querySelector(".js-intro-txt");
        const intro = document.querySelector(".intro");

        if (!txtr === null) {
            txtr.addEventListener("animationend", () => {
                intro.classList.add("txtend");
            });
        }
    }
}
